import React, { useMemo } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component';
import {
    mastercard,
    paypal,
    visacard,
} from '../../assets/images';

export default function Payment() {

    const columnsFilter = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Client Name',
            selector: row => row.clientName,
            sortable: true,
        },
        {
            name: 'Project Name',
            selector: row => row.projectName,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row.type,
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            sortable: true,
        },
    ];

    const dataFilter = [
        {
            id: 'LA 0218',
            clientName: 'Lucid',
            projectName: 'Alpino - Bootstrap 4',
            date: '07 March, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            amount: '$4,205'
        },
        {
            id: 'LA 0220',
            clientName: 'Lucid',
            projectName: 'Nexa Wordpress',
            date: '25 Jun, 2021',
            type: <img src={mastercard} alt='paymrnt type' className='w-[50px]' />,
            amount: '$5,205'
        },
        {
            id: 'LA 0222',
            clientName: 'Lucid',
            projectName: 'Lucid HR Management',
            date: '12 July, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            amount: '$2,000'
        },
        {
            id: 'LA 0312',
            clientName: 'Lucid',
            projectName: 'sQuare - Bootstrap 4 Angular5 Admin',
            date: '13 July, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            amount: '$10,000'
        },
        {
            id: 'LA 0389',
            clientName: 'Lucid',
            projectName: 'Compass Dashboard',
            date: '27 July, 2021',
            type: <img src={visacard} alt='paymrnt type' className='w-[50px]' />,
            amount: '$1,205'
        },
    ]

    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = dataFilter.filter(
        item =>
            item.id.toLowerCase().includes(filterText.toLowerCase()) ||
            item.clientName.toLowerCase().includes(filterText.toLowerCase()) ||
            item.projectName.toLowerCase().includes(filterText.toLowerCase()) ||
            item.date.toLowerCase().includes(filterText.toLowerCase()) ||
            item.amount.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className='flex gap-5 mb-10 w-full justify-end'>
                <div className='relative w-full max-w-[221px]'>
                    <input
                        type='text'
                        id='search'
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        placeholder='Search here...'
                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
                    />
                </div>
                <button onClick={handleClear} className="btn btn-danger">
                    Clear
                </button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
            <Breadcrumb title="Payments" path="Accounts / Payments" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='react-data-table'>
                    <ReactDataTable
                        columns={columnsFilter}
                        data={filteredItems}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                    />
                </div>
            </div>
        </>
    )
}
